import { general } from "./general"
import { CorporationMember } from "./corporationMember"
import { User } from "./user"

export const Request = {
  general,
  CorporationMember,
  User,
}
